import { FC, ReactNode } from 'react';
import BordOneToneIcon from '../NudosComponents/BordOneToneIcon/BordOneToneIcon';
import { CTA_TYPE, IBordTooltipProps } from './BordTooltip.type';
import { NudosButton } from '../NudosComponents';

import '../BordTooltip/BordTooltip.scss';

const BordTooltip: FC<IBordTooltipProps> = ({
  message,
  position = 'top',
  children,
  ctaType = CTA_TYPE.noCta,
  ctaLabel,
  oneCtaVariant,
  ctaAction,
  customJSXMessage,
  ctaButtonOneLabel,
  ctaButtonOneAction,
  ctaButtonTwoLabel,
  ctaButtonTwoAction,
  customStyles,
  customStylesTooltipContainer,
  tooltipMouseEnter
}) => {
  const positionClasses: { [key: string]: string } = {
    top: 'tooltipTop',
    bottom: 'tooltipBottom',
    left: 'tooltipLeft',
    right: 'tooltipRight',
    bottomRight: 'tooltipBottomRight',
    bottomLeft: 'tooltipBottomLeft'
  };

  const oneCtaVariantDefault = 'arrowRightCircle';

  const ctaComponents: { [key in CTA_TYPE]: ReactNode } = {
    [CTA_TYPE.noCta]: null,
    [CTA_TYPE.oneCta]: (
      <div className="oneCta" onClick={ctaAction}>
        <div>{ctaLabel}</div>
        <BordOneToneIcon variant={oneCtaVariant ?? oneCtaVariantDefault} customWidth="3.84rem" />
      </div>
    ),
    [CTA_TYPE.twoCta]: (
      <div className="twoCta">
        <NudosButton
          colorPalette="primary"
          customClassName="whitespace-nowrap w-full"
          handleClick={ctaButtonOneAction}
          buttonText={ctaButtonOneLabel}
        />
        <NudosButton
          colorPalette="secondary"
          customClassName="whitespace-nowrap w-full"
          handleClick={ctaButtonTwoAction}
          buttonText={ctaButtonTwoLabel}
        />
      </div>
    )
  };

  return (
    <div
      className={`bordTooltipContainer relative group flex items-center ${
        customStylesTooltipContainer ? customStylesTooltipContainer : 'w-max'
      }`}
      onMouseEnter={() => tooltipMouseEnter?.()}
    >
      {children}
      {!!message && (
        <div className={`bordTooltipMessageContainerLegacy ${positionClasses[position]} ${customStyles}`}>
          <div className="messageText">{message}</div>
          {ctaType !== CTA_TYPE.noCta && <div className="ctaDivider" />}
          {ctaComponents[ctaType]}
        </div>
      )}
      {!!customJSXMessage && (
        <div className={`bordTooltipMessageContainer ${positionClasses[position]} ${customStyles}`}>
          {customJSXMessage}
        </div>
      )}
    </div>
  );
};

export default BordTooltip;
